import type { auth as pt } from '../pt-BR/auth';
import type { Traducao } from '../Traducao';

export const auth = {
  loginTitle: 'Sign in',
  loginSubtitle: 'Sign in to your account to continue.',
  tagline: 'Your backoffice platform.',
  email: 'Email',
  password: 'Password',
  submit: 'Sign in',
  passwordShow: 'Show password',
  passwordHide: 'Hide password',
  azureSignIn: 'Sign in with Microsoft',
  orContinueWith: 'or continue with email',
  invalidCredentials: 'Invalid email or password.',
  azureCallbackPending: 'Completing Microsoft sign-in...',
  azureCallbackFailed: 'Could not complete sign-in. Please try again.',
  logout: 'Sign out',
  avisoEmailNt: {
    titulo: 'Use your NTConsult e-mail',
    texto:
      'Sign in with your @ntconsult.com.br or @ntconsultcorp.com e-mail. Do not use the e-mail of the client where you work, even if it is a Microsoft account.',
    dica: 'Use your NTConsult e-mail (@ntconsult.com.br or @ntconsultcorp.com).',
  },
} as const satisfies Traducao<typeof pt>;
